import { render, staticRenderFns } from "./Franchising.vue?vue&type=template&id=75cac648&"
import script from "./Franchising.vue?vue&type=script&lang=js&"
export * from "./Franchising.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports